import {AxiosPromise} from "axios"
import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"
import {AttributeData} from "../store/entities/Attribute"


export interface CompareApiGet {
    category_id: number
    attribute_id: number
    ozonAttributeName: string
    entitiesName: string
}

export interface waFeatureValues {
    values: {
        dictionary_value: {
            id: string
            dictionary_id: string
            dictionary_value: string
        } | null
        feature_value: string
        feature_value_id: string
    }[]
    type: string
}

export interface CompareApiSave {
    id?: number
    dictionary_id: string | number
    feature_value_type: string
    feature_value_id: number
    ozon_attribute_id: number
    ozon_category_id: number
}

export default class ValuesCompareApi {
    public static get(data?: { attribute_id: string, category_id: string }): AxiosPromise<ActionAnswer<{ data: CompareApiGet, name: string, attribute_name: string }>> {
        return RequestHelper.send("get", "valueCompare", data)
    }

    public static savePair(data: CompareApiSave): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "valueCompare", data)
    }

    public static deletePairWith(pair_id: number): AxiosPromise {
        return RequestHelper.send("delete", "valueCompare", {pair_id})
    }

    static getValuePairs(attribute_id: number, category_id?: number): AxiosPromise<ActionAnswer<waFeatureValues>> {
        return RequestHelper.send("get", "valueCompare&action=getValuesPairs", {attribute_id, category_id})
    }

    public static saveEntities(data: CompareApiSave[]): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "valueCompare&action=saveEntities", {entities: data})
    }
}